// Черновик рассылки: что введено на странице «Рассылка в WhatsApp» (название, шаблон, его поля,
// список, отправка). Без него всё пропадало, стоило уйти на «Списки» и вернуться назад.
// Хранится в sessionStorage: живёт, пока открыта вкладка браузера, и не всплывает через неделю.

const KEY = 'gradoil.whatsapp.draft';

const storage = () => {
  try {
    return typeof window !== 'undefined' ? window.sessionStorage : null;
  } catch (err) {
    return null;
  }
};

export const loadDraft = () => {
  try {
    const raw = storage() && storage().getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (err) {
    return null;
  }
};

export const saveDraft = (draft) => {
  try {
    if (storage()) storage().setItem(KEY, JSON.stringify(draft));
  } catch (err) {
    // Хранилище недоступно (приватный режим): черновик просто не сохранится.
  }
};

export const clearDraft = () => {
  try {
    if (storage()) storage().removeItem(KEY);
  } catch (err) {
    // См. saveDraft.
  }
};
